
import { Component } from 'vue-property-decorator';
import { ActivitySettings, SettingsApiControllerUIClient } from '../../../backend/backendapi';
import { handleError, initClient } from '../../../../api';
import Vue from 'vue';
import ActivitySettingsSwitch from './ActivitySettingsEditor/ActivitySettingsSwitch';
import { fixISettings } from '../../../../util';

@Component({
  components: {
    ActivitySettingsSwitch,
  },
})
export default class ActivitySettingsEditor extends Vue {
  readonly settingsAPI = initClient(SettingsApiControllerUIClient);
  activitySettings: ActivitySettings | null = null;

  mounted() {
    fixISettings();
    this.reload();
  }

  async reload(): Promise<void> {
    const set2 = (await this.settingsAPI.get('ActivitySettings', false, false)).result!;
    this.activitySettings = new ActivitySettings();
    this.activitySettings.init(set2);
  }

  async save(): Promise<void> {
    try {
      await this.settingsAPI.update('ActivitySettings', false, false, JSON.stringify(this.activitySettings));
      this.$toasted.info(this.$t('txtSaved').toString());
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    }
  }
}
